import SecureRequest from "utils/securerequest";

export interface MappedCptCode {
  id: number;
  code: string;
  description: string | null;
}

export interface MappedCptCodes {
  assessment: MappedCptCode | null;
  directTherapy: MappedCptCode | null;
  caregiverMediated: MappedCptCode | null;
  caregiverTraining: MappedCptCode | null;
  protocolModificationDirect: MappedCptCode | null;
  protocolModificationIndirect: MappedCptCode | null;
}

export async function getMappedCptCodes(planId: number) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.get(`/v3/insurance-plans/${planId}/mapped-cpt-codes`);
}
